import React from 'react';
import { Modal } from '@gerdau/hefesto';
import { NoProductsContainer } from './styles';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';

interface UnavailableProductsModalProps {
  items: string[];
  enabled: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const UnavailableProductsModal = ({
  items,
  enabled,
  onConfirm,
  onClose
}: UnavailableProductsModalProps) => {
  const dispatch = useDispatch();
  if (!enabled) {
    return null;
  }

  const handleClickModalTagging = (navButton: string) => {
    dispatch(
      sendTagging({
        event: 'click',
        screenName: 'comprar_por_historico',
        botao_navegacao: navButton
      })
    );
  };

  return (
    <Modal
      title="Produtos indisponíveis"
      modalSize="md"
      buttons={{
        right: {
          children: 'Avançar para o carrinho',
          name: 'confirm-btn',
          onClick: () => {
            handleClickModalTagging('avançar para o carrinho');
            onConfirm();
          },
          type: 'button'
        },
        left: {
          children: 'Voltar',
          name: 'go-back-btn',
          onClick: () => {
            handleClickModalTagging('Clique no botão voltar');
            onClose();
          },
          type: 'button'
        }
      }}
    >
      <NoProductsContainer>
        <ul>
          {items.map((i) => (
            <li>{i}</li>
          ))}
        </ul>
      </NoProductsContainer>
      <br />
      <NoProductsContainer>
        Alguns produtos do seu antigo pedido estão indisponíveis. Deseja avançar
        para o carrinho sem eles?
      </NoProductsContainer>
    </Modal>
  );
};
